import { Button, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
const { dashboard } = en;
import { CustomRadio } from '../../../../lib/CustomRadio';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { fetchInvestorDetails } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../../redux-store/types/portfolio';
import { DEBT, EQUITY, LIQUID, OTHER, TaxStatusRIArray } from '../../../../utils/constants';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import {
    getInvestorFunds,
    notLockedFolio,
    portfoliosByChangeofTaxStatus,
    portfoliosByDividend,
    portfoliosByModeOfHolding,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { getMatchAndUnMatchedFunds } from '../../../../utils/utilityFunctions';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import NoFoliosFound from '../NoFoliosFound';

export const BANK_ACCOUNT_TYPE = dashboard.ChangeTaxStatus.option1;
export const BANK_ACCOUNT_DETAILS = dashboard.ChangeTaxStatus.option2;

const MenuList = [
    {
        label: BANK_ACCOUNT_TYPE,
        value: BANK_ACCOUNT_TYPE,
    },
    {
        label: BANK_ACCOUNT_DETAILS,
        value: BANK_ACCOUNT_DETAILS,
    },
];

export const Columns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'FOLIO',
    },
    {
        field: 'amcName',
        headerName: 'Fund House',
        width: 200,
        filterBy: true,
        filterHeader: 'Fund House',
        filterKey: 'amcName',
    },
    {
        field: 'investorName',
        headerName: 'PRIMARY HOLDER',
        width: 200,
    },
    {
        field: 'taxStatusLabel',
        headerName: 'TAX RESIDENCY STATUS',
        width: 100,
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];

function ChangeTaxStatus(props: any) {
    const [statusChange, setStatusChange] = useState<string>(BANK_ACCOUNT_TYPE);
    const [loading, setLoading] = useState<boolean>(false);
    const [rowData, setRowData] = useState<ConsolidateTableRowType[]>([]);
    const {
        setSelectedRows,
        selectedRows: targetFunds,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<ConsolidateTableRowType[]>({
        rows: rowData,
        columns: Columns,
        loading,
    });
    useEffect(() => {
        setLoading(true);
        async function callApi() {
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                mobile: props.mobile,
                pekrn: props.pekrn,
                reqId: props.reqId,
            };
            try {
                const { body: investorDetails = {} } = await props.fetchInvestorDetails(payload);
                const { success: investorFunds = [] } = investorDetails;
                const investorFundsRowData = getInvestorFunds(investorFunds, [
                    portfoliosByModeOfHolding,
                    portfoliosByTransactionResource,
                    portfoliosByChangeofTaxStatus,
                ]);

                const processedData = getMatchAndUnMatchedFunds(
                    [notLockedFolio],
                    investorFundsRowData,
                    true,
                );

                setRowData(processedData);
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        return () => { };
    }, []);

    const _isRowSeletable = ({ row }: { row: ConsolidateTableRowType }) => {
        if ((row as any).isDisabled) {
            return false;
        }
        if (targetFunds.length) {
            const [fund] = targetFunds;
            const rowBank = row?.bank.find((bank) => bank.default === 'Y');
            const addedFund = TaxStatusRIArray.includes((fund?.taxStatus || '').toUpperCase())
                ? 'RI'
                : 'NRI';

            const rowFund = TaxStatusRIArray.includes((row?.taxStatus || '').toUpperCase())
                ? 'RI'
                : 'NRI';
            if (!(rowFund === addedFund && rowBank?.accountNo === targetBank?.accountNo)) {
                return false;
            }
        }
        return true;
    };

    const targetBank = useMemo(() => {
        const [fund] = targetFunds;
        return fund?.bank?.find((bank) => bank.default === 'Y');
    }, [targetFunds]);

    const Table = useMemo(() => {
        return !loading && !tableRows.length ? (
            <NoFoliosFound />
        ) : (
            <TableWithCollapse
                rows={tableRows}
                columns={tableColumns}
                isRowSelectable={_isRowSeletable}
                toolTipTextGetter={({ row }) =>
                    _isRowSeletable({ row }) ? '' : dashboard.ChangeTaxStatus.toolTip.info
                }
                setSelectedRows={setSelectedRows}
                selectedRows={targetFunds}
                disableAllSelection
                toolTipEnabled
                checkBoxEnabled
                {...filters}
            />
        );
    }, [tableRows, tableColumns, targetFunds, filters, loading]);

    const _onNext = () => {
        props.history.push('change-tax-upload', {
            targetFunds: targetFunds,
            statusChange: statusChange,
        });
    };

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    };

    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                foliosArray={targetFunds}
                callBackFn={_onNext}
                trxnType={NFT_TRXN_TYPE_MAP.changeOfTaxStatus}
                triggerCheck={callPanSeed}
                goBack={false}
                resetTrigger={resetTrigger}
            />
            <ActionHeader
                subHeader={dashboard.ChangeTaxStatus.ChangeTaxStatusHeadingSpan}
                header={dashboard.ChangeTaxStatus.ChangeTaxStatusHeading}
            />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <CustomRadio
                        extraClass="custom-radio change-tax-radio desktop_mode"
                        title={dashboard.ChangeTaxStatus.radioHeading}
                        name="select-dividend"
                        list={MenuList}
                        selectedValue={statusChange}
                        handleRadioChange={(value: string) => setStatusChange(value)}
                    />
                    <FormControl variant="filled" className="mobile_mode">
                        <InputLabel id="change-tax-option-label">
                            {dashboard.ChangeTaxStatus.radioHeading}
                        </InputLabel>
                        <Select
                            labelId="change-tax-option-label"
                            id="change-tax-option"
                            onChange={(e: any) => setStatusChange(e?.target?.value)}
                            value={statusChange}
                        >
                            {MenuList.map((item) => (
                                <MenuItem key={item.label} value={item.value}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <h5> {dashboard.ChangeTaxStatus.ChangeTaxStatusInfo}</h5>
                    {Table}
                    {/* <FaqLink section={TAX_STATUS} history={props.history} /> */}
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {!!rowData.length && (
                        <div className="table-submit">
                            <SubmitButton
                                disabled={!targetFunds.length}
                                label={dashboard.ChangeTaxStatus.buttonText}
                                className="customBtn"
                                onClick={() => setCallPanSeed(true)}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    fetchInvestorDetails,
})(ChangeTaxStatus);
